module.exports = __webpack_public_path__ + "static/media/item_8_13_comp.7e5bf56c.png";